export default __webpack_public_path__ + "static/media/hi-c.dff1ba60220bcdec2968908e38660b80.mp3";